import { Skeleton } from '@/components/ui/skeleton'

import { OpenChat } from './actions/open-chat'

export const NotificationSkeleton = () => {
  return (
    <div className="flex gap-1.5">
      <div className="relative w-max pr-2">
        <Skeleton className="h-11 w-11 rounded-full dark:bg-skeleton" />
      </div>
      <div className="max-w-full flex-1 space-y-3 overflow-hidden border-b pb-4">
        <div className="space-y-1">
          <Skeleton className="h-[18px] w-1/2 dark:bg-skeleton" />
          <Skeleton className="h-4 w-[90%] dark:bg-skeleton" />
          <Skeleton className="h-[18px] w-1/3 dark:bg-skeleton" />
          <Skeleton className="h-4 w-1/2 dark:bg-skeleton" />
        </div>
        <OpenChat disabled />
      </div>
    </div>
  )
}
